// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
\$font-regular: 400;
\$font-medium: 500;
\$font-semiBold: 600;
\$font-bold: 700;
\$font-extraBold: 800;
\$font-black: 900;

\$mainBg: #F5F6FA;
\$primary-color: #131F43;
\$icon-bgcolor: #F6F6F6;
\$text-graycolor: #727272;
\$cardIcon1-bg: #F3F4F8;
\$cardIcon1-darkbg: #30231a;
\$cardIcon1-darkbg-icon: #9d785f;
\$cardIcon2-bg: #FAF4FB;
\$cardIcon2-darkbg: #13252a;
\$cardIcon2-darkbg-icon: #3b606a;
\$cardIcon3-bg: #FAF7F3;
\$cardIcon3-darkbg: #2c1a27;
\$cardIcon3-darkbg-icon: #6c4863;
\$cardIcon4-bg: #F5F9FC;
\$cardIcon4-darkbg: #241d3e;
\$cardIcon4-darkbg-icon: #5f538b;
\$cardIcon2-color: #AC44BB;
\$cardIcon3-color: #D69A5F;
\$cardIcon4-color: #176CA5;
\$green-color: #38A169;
\$darkGreen-color: #207a4a;
\$placeholder-color: #666666;
\$profile-dark-text: #181818;
\$heading : #0B0D0F;
\$light-gray : #999999;
\$menu_icon : #CBCBCB;
\$red-color : #F94747;
\$dark-active-blue : #3b82f6;
\$dark-light-blue : #92afd3;
\$addBtn-dark-blue : #3b82f6;
\$addBtn-dark-blue-hover : #2563eb;
\$backBtn-dark : #3b82f633;



\$darkTheme_blue : #132337;
\$darkTheme_darkBlue : #0f1824;
\$darkTheme_selectBlue : #1c2e45;
\$darkTheme_updateBtn : #0a2574;

/* 
Body Theme Color
 */
\$lightthemecolor: #f3f6f9;
\$darkthemecolor: #151521;

\$white-color: #fff;
\$black-color: #1d1d1d;
\$fullBlack-color: #1d1d1d;
\$lightthemetext: #60677e;

/* 
Dark Theme Colors
*/
\$primarydark-color: #132337;

/* 
Button Theme
*/
\$primary-btncolor: #131F43;
\$secondary-btncolor: rgba(37, 105, 109, 0.864);

\$tableheadlightbg: #e9eaf0;


/* 
Max Dashboard scss
*/
\$dashboardwidth: calc(100% - 320px);
\$dashboardposition: absolute;
\$dashboardleft: 310px;
\$dashboardpadding: 30px;

/* 
Min Dashboard scss
*/
\$dashwidth: calc(100% - 50px);
\$dashleft: 50px;

/* 
Max Dashboard scss
*/

.dashboard {
  width: \$dashboardwidth;
  position: relative;
  left: \$dashboardleft;
  padding: \$dashboardpadding;
  border-radius: 8px;
  min-height: auto !important;
  background-color: \$mainBg;
  height: calc(100vh - 160px);
  overflow-y: auto;
}
.dashboardContain { 
  width: calc(100% - 320px);
  background-Color:\$mainBg;
  border-radius: 8px;
}
.bodythemedark .dashboardContain,
.bodythemedark .dashboard, 
.bodythemedark .cont2 { 
  background-Color: \$darkTheme_darkBlue;
}
.top_header .top_header_inner {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/

.cont2 {
  width: \$dashwidth;
  left: \$dashleft;
  position: relative;
  padding: \$dashboardpadding;
  border-radius: 8px;
  background: \$mainBg;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
background-Color: \$dashboardbackgroundColor;
  padding-bottom: 8%;
*/
}




.footer {
  height: 70px;
}

body {
  background-color: \$white-color;
}

/* 
THEME CHANGE
*/
.bodythemelight {
  background-color: \$white-color;
  padding-top: 90px;
}
.bodythemedark {
  background-color: \$darkTheme_blue;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.headerthemelight {
  background-color: \$white-color;
}

.headerthemedark {
  background-color: \$darkTheme_blue;
}
.top_header {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1; 
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.menuthemelight {
  background-color: \$white-color;
}
.menuthemedark {
  background-color: \$darkTheme_blue;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.menulinklight span {
  color: \$placeholder-color !important;
}

.menulinklight a {
  color: \$menu_icon !important;
}

.menulinklight:hover span, .menulinklight:hover a { 
  color: \$white-color !important;
}

.menulinkdarkSelected {
  background-color: \$darkTheme_selectBlue;
  color: \$dark-active-blue;
}
.menuthemelight .menulinklightSelected {
  /*background-color: \$lightthemecolor;*/
  color: \$white-color !important;
  background-color: \$primary-color;
}

.menulinkdark {
  color: \$dark-light-blue !important;
}

.menulinklight:hover {
  color: \$white-color !important;
  background-color: \$primary-color;
}

.menulinklight .sub_arrow svg path{
  stroke: \$menu_icon !important;
}

.menulinklight:hover .sub_arrow svg path{
  stroke: \$white-color !important;
}

.menulinkdark .sub_arrow svg path{
  stroke: \$dark-light-blue !important;
}

.menulinkdark:hover .sub_arrow svg path{
  stroke: \$white-color !important;
}

.menulinkdark:hover {
  background-color: \$darkTheme_selectBlue;
  color: \$white-color;
}

/* 
BODY HEADERS
*/
.headinglight {
  color: \$lightthemetext;
}

.headingdark {
  color: \$lightthemetext;
}

/* 
SEARCH BOX THEME COLOR
*/
.searchboxlight {
  background-color: \$white-color;
  border: none;
}

.searchboxdark {
  background-color: \$darkTheme_blue;
  color: \$white-color;
  border: none;
}
.searchboxdark::placeholder {
  color: \$lightthemetext;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.tableheadlight {
  background-color: \$primary-color;
  border-radius: 5px 5px 0px 0px;
}
.tableheadlight th {
  color: \$white-color;
}
thead .tableheadlight th:first-child,
thead .tableheaddark th:first-child {
  border-radius: 5px 0 0 0px;
} 
thead .tableheadlight th:last-child,
thead .tableheaddark th:last-child  {
  border-radius: 0 5px 0px 0;
}
th:first-child {
  border-radius: 0px;
} 
td:last-child {
  border-radius: 0px;
}
table.table.table-borderless{
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.tableheaddark {
  background-color: \$primarydark-color;
  color: \$white-color;
}
.table-borderless tr:nth-child(even) {
  background-color: #F9FAFB;
}
.table-borderless .left-section {
  padding-top: 10px;
}
.tablebodylight td, 
.tablebodydark td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}
.tablebodylight {
  background-color: \$white-color;

  &:hover {
    background-color: #ddecf9;
    cursor: auto;
  }
}
.tablebodydark {
 /* background-color: \$primarydark-color; */
  color: \$lightthemetext;

  &:hover {
    background-color: rgba(33, 150, 243, 0.1);
    cursor: auto;
  }
}

/* 
PAGINATION THEME COLOR
*/
.paginationlight {
  color: \$lightthemetext !important;
  font-size: 13px !important;
}
.paginationdark {
  color: \$lightthemetext !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.formthemelight {
  background-color: \$white-color;
  color: \$black-color !important;
  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);
}
.formthemedark {
  background-color: \$primarydark-color;
  color: \$lightthemetext !important;
  font-size: 14px;

  ::placeholder {
    color: \$lightthemetext;
  }
}


/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.viewformlight {
  background-color: \$lightthemecolor;
}

.permissionboxlight {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}
.permissionboxdark {
  background-color: \$darkTheme_darkBlue;
  border: solid 1px #242434;
}

.errormsgclr {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.graphclrlight {
  background-color: \$white-color;
}

.graphclrdark {
  background-color: \$primarydark-color;
}


/* 
Counter theme
*/
#card1bglight {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: \$white-color;
}

#card1bgdark {
  background: #392f28;
}

#card2bglight {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: \$white-color;
}

#card2bgdark {
  background: #1c3238;
}

#card3bglight {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: \$white-color;
}

#card3bgdark {
  background: #3a2434;
}

#card4bglight {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: \$white-color;
}

#card4bgdark {
  background: #2f264f;
}

#card1bgdark a, #card1bgdark p,
#card2bgdark a , #card2bgdark p,
#card3bgdark a, #card3bgdark p,
#card4bgdark a, #card4bgdark p {
  color: \$white-color;
}

/* 
Action button theme
*/
.actionbtnlight {
  color: #46475bde;
}
.actionbtnlight:hover{
  cursor: pointer;
}
.actionbtndark {
  color: \$lightthemetext;
}


/* 
profile dropdowntheme
*/
.profiledropdownlight {
  background-color: #fff;
}

.profiledropdowndark {
  background-color: #151521;
}

.settingsection #addform.formthemedark .savebtn {
  background-color: \$addBtn-dark-blue;
  color: \$white-color;
}
#addform.formthemedark .savebtn {
  background-color: \$addBtn-dark-blue;
  color: \$white-color;
}

.profile_conatiner {
  border-radius: 5px !important; 
}

.bodythemedark .ag-theme-alpine .ag-row {
  background: #000 !important;
}

.bodythemedark .formbtn {
  background-color: \$addBtn-dark-blue;
}

.bodythemedark .formbtn:hover {
  background-color: \$addBtn-dark-blue-hover;
}

.bodythemedark .resetbtn {
  color: \$white-color;
  background-color: transparent;
  border: solid 1px \$addBtn-dark-blue;
}

.bodythemedark .resetbtn:hover {
  background-color: \$addBtn-dark-blue;
}


.headingdark span {
  background-color: \$darkTheme_blue;
}

.resetbtn {
  font-size: 16px;
  font-weight: \$font-semiBold;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px \$primary-color;
  color:  \$primary-color;
  min-width: 113px;
}
.resetbtn:hover, 
.resetbtn:active, 
.resetbtn:focus {
  background-color: \$primary-color;
  color: \$white-color;
}

.addBtn {
  min-width: 140px;
  height: 44px;
  color: \$white-color;
  background-color: \$green-color;
  border: none;
  font-size: 16px;
  font-weight: \$font-semiBold;
}

.addbtnlight {
  background-color: \$green-color;
}
.addbtndark {
  background-color: \$addBtn-dark-blue;
}
.addbtndark:hover {
  background-color: \$addBtn-dark-blue-hover;
}

.formthemedark label {
  color: \$dark-light-blue;
}


.addBtn svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.addBtn:hover {
  color: \$white-color;
  background-color: \$green-color;
  border: none;
}

.cust_addBtn.addBtn svg {
  top: 2px;
}

.deleteBtn {
  min-width: 130px;
  height: 50px;
  background-color: \$red-color;
  color: \$white-color;
  font-size: 16px;
  font-weight: \$font-semiBold;
  border: none;
}

.deleteBtn {
  min-width: 130px;
  height: 50px;
  background-color: \$red-color;
  color: \$white-color;
  font-size: 16px;
  font-weight: \$font-semiBold;
  border: none;
}

.deleteBtn:active, .deleteBtn:focus {
  background-color: \$red-color !important;
  color: \$white-color !important; 
  box-shadow: none !important;
}

.deleteBtn svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.deleteBtn:hover, 
.deleteBtn:active, 
.deleteBtn:focus {
  background-color: \$red-color;
  color: \$white-color;
  border: none;
}

.confirmBtn {
  background-color: \$primary-color;
}

.confirmBtn:hover, 
.confirmBtn:active, 
.confirmBtn:focus {
  background-color: \$primary-color;
}

.confirmBtn svg {
  top: 0;
}



.delPopContainer .modal-body {
  padding: 25px;
  text-align: center;
}

.delPopContainer .delet_icon {
  margin-bottom: 11px;
}

.delPopContainer p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.arrowback svg{
  fill: #000; 
}

.bodythemedark .arrowback {
  background-color: \$backBtn-dark; 
  color: \$dark-active-blue;
}

.bodythemedark .arrowback svg {
  fill: \$dark-active-blue;
}

.bodythemedark .drpdwn_btn {
  background-color: \$darkTheme_blue;
}

.bodythemedark .empname {
  color: \$dark-light-blue !important;
}

.bodythemedark .navitemli a {
  background-color: transparent;
  border: solid 1px \$addBtn-dark-blue;
  color: \$white-color;
}

.bodythemedark .tabnavli a.settingsgeneral, 
.bodythemedark .tabnavli a.settingslinks:hover {
  background-color: \$addBtn-dark-blue;
  color: \$white-color;
}
.bodythemedark .tabnavli a.settingslinks {
  background-color: transparent;
  border: solid 1px \$addBtn-dark-blue;
  color: \$white-color;
}

.headerthemedark .dropdown_menu_contain {
  background-color: \$darkTheme_selectBlue;
  color: \$white-color;
}

.headerthemedark .dropdown_menu_contain ul li a,
.headerthemedark .dropdown_menu_contain .dropdown_item, 
.headerthemedark .dropdown_menu_contain .dropdown_item h5 {
  color: \$white-color;
}

.headerthemedark .dropdown_menu_contain ul li a:hover,
.headerthemedark .dropdown_menu_contain .dropdown_item:hover {
  background-color: \$darkTheme_blue;
  color: \$white-color;
}

.dropdown_item:active {
  background-color: \$mainBg;
}

.profile_arrrow_dwn {
  stroke: \$darkTheme_blue;
}

.headerthemedark .profile_arrrow_dwn {
  stroke: \$white-color;
}

.dateinputbox1 input, 
.dateinputbox1 span {
  color: \$white-color !important;
}

/* LOGOUT MODAL */
.modalStyleLight {

}

.modalStyleDark {
  
}


@media only screen and (max-width: 1200px) {
  .tableheadlight th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) { 
  .dashboard {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .cont2 {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) { 
 /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (max-width: 767px) { 
  .sectionright{
    float: unset !important;
  }
  .dashboard {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .cont2 {
    width: \$dashwidth !important;
    left: \$dashleft !important;
    position: relative !important;
    padding: 10px !important;
  }
  .bodythemelight, .bodythemedark {
    padding-top: 110px;
  }
}

@media (min-width: 576px) {
  .exer_modal_contain .modal-dialog {
      max-width: 1055px;
  }
  .delPopContainer .modal-dialog {
      max-width: 350px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss"],"names":[],"mappings":"AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE;AACF,kBAAkB;AAClB,iBAAiB;AACjB,mBAAmB;AACnB,eAAe;AACf,oBAAoB;AACpB,gBAAgB;;AAEhB,gBAAgB;AAChB,uBAAuB;AACvB,sBAAsB;AACtB,wBAAwB;AACxB,sBAAsB;AACtB,0BAA0B;AAC1B,+BAA+B;AAC/B,sBAAsB;AACtB,0BAA0B;AAC1B,+BAA+B;AAC/B,sBAAsB;AACtB,0BAA0B;AAC1B,+BAA+B;AAC/B,sBAAsB;AACtB,0BAA0B;AAC1B,+BAA+B;AAC/B,yBAAyB;AACzB,yBAAyB;AACzB,yBAAyB;AACzB,qBAAqB;AACrB,yBAAyB;AACzB,2BAA2B;AAC3B,2BAA2B;AAC3B,kBAAkB;AAClB,qBAAqB;AACrB,oBAAoB;AACpB,oBAAoB;AACpB,2BAA2B;AAC3B,0BAA0B;AAC1B,2BAA2B;AAC3B,iCAAiC;AACjC,yBAAyB;;;;AAIzB,yBAAyB;AACzB,6BAA6B;AAC7B,+BAA+B;AAC/B,8BAA8B;;AAE9B;;EAEE;AACF,yBAAyB;AACzB,wBAAwB;;AAExB,kBAAkB;AAClB,qBAAqB;AACrB,yBAAyB;AACzB,wBAAwB;;AAExB;;CAEC;AACD,2BAA2B;;AAE3B;;CAEC;AACD,0BAA0B;AAC1B,8CAA8C;;AAE9C,0BAA0B;;;AAG1B;;CAEC;AACD,mCAAmC;AACnC,4BAA4B;AAC5B,qBAAqB;AACrB,uBAAuB;;AAEvB;;CAEC;AACD,6BAA6B;AAC7B,eAAe;;AAEf;;CAEC;;AAED;EACE,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;;;EAGE,qCAAqC;AACvC;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;CAEC;;AAED;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB;;;CAGD;AACD;;;;;AAKA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;CAEC;AACD;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;CAEC;AACD;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,UAAU;EACV,MAAM;AACR;;AAEA;;CAEC;AACD;EACE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;;AAEA;;CAEC;AACD;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;AACA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;CAEC;AACD;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;CAEC;AACD;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;;AAEA;;CAEC;AACD;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,8BAA8B;;EAE9B;IACE,yBAAyB;IACzB,YAAY;EACd;AACF;AACA;CACC,0CAA0C;EACzC,sBAAsB;;EAEtB;IACE,yCAAyC;IACzC,YAAY;EACd;AACF;;AAEA;;CAEC;AACD;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;;CAEC;AACD;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,iDAAiD;AACnD;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;;EAEf;IACE,sBAAsB;EACxB;AACF;;;AAGA;;CAEC;AACD;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;;CAEC;AACD;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;;CAEC;AACD;EACE,iGAAiG;EACjG,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gGAAgG;EAChG,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gGAAgG;EAChG,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gGAAgG;EAChG,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;CAEC;AACD;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;;AAGA;;CAEC;AACD;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;;AAGA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;;EAGE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;;;EAGE,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,MAAM;AACR;;;;AAIA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;;AAEA;;AAEA;;AAEA;;;AAGA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,mCAAmC;IACnC,qBAAqB;IACrB,6BAA6B;EAC/B;EACA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;AACF;AACA;CACC;;IAEG;AACJ;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,wBAAwB;EAC1B;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;MACI,iBAAiB;EACrB;EACA;MACI,gBAAgB;EACpB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 310px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
